import React from "react";
import {
  Col,
  Container,
  ListGroupItem,
  Modal,
  ModalBody,
  Row,
} from "reactstrap";
import close from "assets/img/icons/createBill/close.png";
import addBill from "assets/img/icons/createBill/addBill.png";
import CompanyProfileRepository from "repository/CompanyProfileRepository";
import LoadMore from "components/Button/LoadMore";
import { ERP_CDN_IMAGE_URL } from "helpers/utils";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Tag } from "primereact/tag";
import Common from "helpers/Common";
import { TiDownload } from "react-icons/ti";

const pageSize = new CompanyProfileRepository().getPageSize();

const CustomerBillHistoryModal = ({
  modal,
  toggle,
  backdrop,
  keyboard,
  customerBillHistoryData,
  customerName,
  handleLoadMore,
  tableData,
  fetchBillDataById,
}) => {
  const PaidStatusBody = (rowData) => {
    const isPaid = 
      rowData?.billStatusName === "Paid" || 
      rowData?.billStatusId === 3 ||
      rowData?.paidStatus === "true";

    return (
      <Tag
        pt={{
          value: {
            style: {
              color: isPaid ? "white" : "",
              fontWeight: "bold",
              fontFamily: "'DM Sans', sans-serif",
            },
          },
        }}
        value={isPaid ? "Paid" : "Unpaid"}
        severity={isPaid ? "success" : "warning"}
      />
    );
  };

  const columns = [
    {
      field: 'action',
      header: 'Load Past Medicines',
      align: 'center',
      body: (rowData) => (
        <div className="d-flex justify-content-around w-100">
          <button
            type="button"
            className="actions-btn"
            onClick={() => {
              fetchBillDataById(rowData.billId), toggle();
            }}
          >
            <TiDownload className="table-action-icon" />
          </button>
        </div>
      )
    },
    { field: 'billId', header: 'Bill ID', align: 'center' },
    {
      field: 'netProductPayment',
      header: 'Net Product Payment',
      align: 'center',
      body: (rowData) => "₹" + Number(rowData.netProductPayment).toFixed(2)
    },
    {
      field: 'applicableTax',
      header: 'Applicable Tax',
      align: 'center'
    },
    {
      field: 'netPayment',
      header: 'Net Payment',
      align: 'center',
      body: (rowData) => "₹" + Number(rowData.netPayment).toFixed(2)
    },
    {
      field: 'paidStatus',
      header: 'Paid Status',
      align: 'center',
      body: PaidStatusBody
    },
    {
      field: 'pendingPayment',
      header: 'Pending Payment',
      align: 'center'
    },
    {
      field: 'paidPayment',
      header: 'Paid Payment',
      align: 'center',
      body: (rowData) => "₹" + Number(rowData.paidPayment).toFixed(2)
    },
    {
      field: 'billCreationDate',
      header: 'Bill Creation Date',
      align: 'center',
      style: { width: '150px' },
      body: (rowData) => Common.getFormatedDate(rowData.billCreationDate, 'DD-MM-YYYY hh:mm:ss A', true)
    }
  ];

  return (
    <>
      <Modal
        isOpen={modal}
        toggle={toggle}
        backdrop={backdrop}
        keyboard={keyboard}
        fullscreen={"xl"}
        size={"xl"}
        centered
      >
        <ListGroupItem>
          <Row xs="2">
            <Col
              xs="11"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
              }}
            >
              <h4
                className="m-0"
                toggle={toggle}
                style={{
                  fontWeight: "bold",
                  fontFamily: "'DM Sans', sans-serif",
                }}
              >
                {customerName}'s Bill History
              </h4>
            </Col>
            <Col
              xs="1"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                width: "100%",
              }}
            >
              <img
                src={`${ERP_CDN_IMAGE_URL}/close.png`}
                onError={(e) => {
                  e.target.onerror = null; // Prevent infinite loop if logo also fails
                  e.target.src = close;
                }}
                alt="X"
                className="create-bill-icon"
                id="close"
                onClick={toggle}
              />
            </Col>
          </Row>
        </ListGroupItem>
        <ModalBody>
          <Container>
            <DataTable value={tableData} scrollable scrollHeight="400px">
              {columns.map((col, i) => (
                <Column 
                  key={i}
                  field={col.field}
                  header={col.header}
                  body={col.body}
                />
              ))}
            </DataTable>
            <div className="loadMore-billHistory mt-3">
              <LoadMore
                totalData={tableData.length}
                handleLoadMore={() => handleLoadMore()}
              />
            </div>
          </Container>
        </ModalBody>
      </Modal>
    </>
  );
};

export default CustomerBillHistoryModal;
